import {MainUrlTypes} from '../types'

export const getUrlByKey = (
	nav: Array<MainUrlTypes>,
	key: 'products' | 'cart' | 'home' | 'downloads' | 'agenda' | string
) => {
	if (!nav || nav.length === 0) return
	return nav.find((item) => item.key === key)
}
